import { SvgIcon } from '@mui/material';
import { FC } from 'react';

import { IconProps } from '../types';

export const SkrillIcon: FC<IconProps> = ({ width = 32, height = 32 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={[0, 0, width, height].join(' ')}
      fill="none"
      stroke="none"
      strokeWidth="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2177_149037)">
        <path
          d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
          fill="url(#paint0_linear_2177_149037)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1913 14.3746C20.6266 14.3746 20.9794 14.0223 20.9794 13.588C20.9794 13.1533 20.6266 12.8008 20.1913 12.8008C19.7565 12.8008 19.4039 13.1533 19.4039 13.588C19.4039 14.0223 19.7565 14.3746 20.1913 14.3746ZM14.1557 14.7994C14.1201 14.8886 13.8642 15.6108 13.2452 16.3592V13.1589L11.5959 13.4845V19.2854H13.2452V17.4923C13.7229 18.2079 13.9587 19.2854 13.9587 19.2854H15.9343C15.7389 18.4739 14.8841 16.9777 14.8841 16.9777C15.6513 16.0061 15.9882 14.9709 16.0418 14.7994H14.1557ZM18.4916 14.7388C17.0144 14.7862 16.2645 15.4482 16.2645 16.7642V19.2854H17.8761V17.2295C17.8761 16.4414 17.9794 16.1037 18.9156 16.0714V14.7619C18.758 14.7285 18.4916 14.7388 18.4916 14.7388ZM8.82982 15.4381C8.62782 15.4249 8.1601 15.3947 8.1601 14.9741C8.1601 14.4666 8.83346 14.4666 9.08602 14.4666C9.5301 14.4666 10.1053 14.5977 10.516 14.7204C10.516 14.7204 10.7451 14.8011 10.9401 14.8837L10.9582 14.8886V13.4987L10.9333 13.4913C10.4486 13.3219 9.88494 13.1589 8.83998 13.1589C7.0383 13.1589 6.3999 14.2074 6.3999 15.1055C6.3999 15.6233 6.62206 16.8418 8.68546 16.9823C8.86038 16.9931 9.32462 17.0198 9.32462 17.4544C9.32462 17.8133 8.94454 18.0249 8.30534 18.0249C7.60478 18.0249 6.92526 17.8464 6.5125 17.6772V19.1087C7.13042 19.2705 7.82694 19.3514 8.6433 19.3514C10.405 19.3514 11.194 18.3594 11.194 17.3763C11.194 16.2615 10.3111 15.5373 8.82982 15.4381ZM19.3924 19.2854H20.991V14.8045H19.3924V19.2854ZM24.0011 13.4446V19.2854H25.5999V13.1589L24.0011 13.4446ZM21.6681 13.4446L23.2655 13.1589V19.2854H21.6681V13.4446Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2177_149037"
          x1="8.65408"
          y1="1.44098e-07"
          x2="25.3641"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6B195F" />
          <stop offset="1" stopColor="#4C255B" />
        </linearGradient>
        <clipPath id="clip0_2177_149037">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
